<template>
  <path d="M16.4999 6.75043H21.7499V12.0004" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M2.25 17.2485L7.93921 11.5593C8.07851 11.42 8.24388 11.3095 8.42589 11.2341C8.6079 11.1587 8.80298 11.1199 9 11.1199C9.19701 11.1199 9.39209 11.1587 9.5741 11.2341C9.75611 11.3095 9.92148 11.42 10.0608 11.5593L12.4392 13.9378C12.5785 14.0771 12.7439 14.1876 12.9259 14.263C13.1079 14.3384 13.303 14.3772 13.5 14.3772C13.697 14.3772 13.8921 14.3384 14.0741 14.263C14.2561 14.1876 14.4215 14.0771 14.5608 13.9378L21 7.49854"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>
